import { render } from "./TabGroup.vue?vue&type=template&id=1b5ddab6&scoped=true"
const script = {}

import "./TabGroup.vue?vue&type=style&index=0&id=1b5ddab6&scoped=true&lang=css"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1b5ddab6"]])

export default __exports__